import {FileTypes} from '../components/shared/inputs/nx-file-upload/file-upload.model';

export const ACCEPTED_IMAGE_FILE_TYPES = [FileTypes.IMAGE_JPG, FileTypes.IMAGE_PNG, FileTypes.IMAGE_JPEG];
export const ACCEPTED_FILE_AND_DOCUMENT_FILE_TYPES = [FileTypes.APPLICATION_PDF, FileTypes.IMAGE_JPG, FileTypes.IMAGE_PNG, FileTypes.IMAGE_JPEG];
export const ACCEPTED_AUDIO_FILE_TYPES = [FileTypes.AUDIO_MP3, FileTypes.AUDIO_MP4, FileTypes.AUDIO_AAC, FileTypes.AUDIO_M4A];
export const ACCEPTED_VIDEO_FILE_TYPES = [FileTypes.VIDEO_MP4];
